import React from 'react';
import * as PropTypes from 'prop-types';
import { Typ20 } from 'dc/Typ';
import BuChart01 from 'dc/Visualizations/BuChart01';
import { Header, BubblesWrapper } from './elements';

function ChStPrt7(props) {
  return (
    <div className={props.className}>
      <Header>
        <Typ20>{props.header_text}</Typ20>
      </Header>
      <BubblesWrapper>
        <BuChart01
          data={props.activityBubbles}
          unit={props.unit_text}
          height={'240px'}
          menuOffset={props.menuOffset}
          id={1}
        />
      </BubblesWrapper>
    </div>
  );
}

ChStPrt7.propTypes = {
  activityBubbles: PropTypes.array,
  className: PropTypes.string,
  header_text: PropTypes.string,
  unit_text: PropTypes.string,
  menuOffset: PropTypes.number,
};

export default ChStPrt7;
